import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [
    "hiddeable",
    "selectable"
  ]

  connect() {}

  renderSelectables(event) {
    if (window.paymentMethodsRendered) return
    
    const provider = event.detail.name

    if (['apple', 'google'].includes(provider)) {
      this.makeWalletSelectable(provider)
    }

    if (this.selectableTargets.length > 1) {
      this.selectableTargets
        .map(target => target.classList.remove("hidden"))
    }

    if (['apple', 'google'].includes(provider)) {
      this.showPaymentGateway("stripe-wallet");
      this.selectButton(this.selectableTargets[0]);
    }
    else {
      this.selectableTargets[0].click()
    }
    window.paymentMethodsRendered = true
  }

  makeWalletSelectable(provider) {
    document
      .getElementById(`${provider}-pay-button`)
      .setAttribute("data-payment-target", "selectable")
  }

  showCreditCard(event) {
    this.showPaymentGateway("stripe-cc");
    this.selectButton(event.currentTarget);
  }

  showWallet(event) {
    this.showPaymentGateway("stripe-wallet");
    this.selectButton(event.currentTarget);
  }

  showDatatrans(event) {
    this.showPaymentGateway("datatrans");
    this.selectButton(event.currentTarget);
  }

  showPaymentGateway(gateway) {
    this.hiddeableTargets.forEach((element) => {
      element.hidden = element.getAttribute("data-payment-gateway") != gateway
    })
  }

  selectButton(currentButton) {
    this.selectableTargets.forEach((element) => {
      const selected = element == currentButton;
      const buttonContainer = element.querySelector('.payment-method-button')
      const selectedIcon =  element.querySelector('.selected-icon')

      if (selected) {
        buttonContainer.classList.add("payment-method-button--selected");
        selectedIcon.hidden = false;
      } else {
        buttonContainer.classList.remove("payment-method-button--selected");
        selectedIcon.hidden = true;
      }
    })
  }
}
